import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LocaleProvider } from './context/LocaleContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ShowroomSection } from './components/ShowroomSection';
import { InventorySection } from './components/InventorySection';
import { AboutSection } from './components/AboutSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import './styles/global.css';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import '@taku-mikami/chat-poc-client';
export const App = () => {
    const recaptchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
    return (_jsx(LocaleProvider, { children: _jsxs(GoogleReCaptchaProvider, { reCaptchaKey: recaptchaKey, children: [_jsx(Header, {}), _jsxs("main", { children: [_jsx(Hero, {}), _jsx(ShowroomSection, {}), _jsx(InventorySection, {}), _jsx(AboutSection, {}), _jsx(ContactSection, {})] }), _jsx(Footer, {}), _jsx("chat-poc-client", { "api-key": "49add269-c51a-4cd2-aa75-e3cee875f758", "widget-css-url": "/chat-poc-widget.css", style: {
                        '--chat-poc-widget-offset-bottom': '100px',
                        '--chat-poc-widget-modal-gap': '-7rem',
                    } })] }) }));
};
